<template>
    <city-selector
        :areaData="areaData"
        :isshowHeader="false"
        :selectCompleted.sync="selectCompleted"
        :selectedProvince.sync="selectedProvince"
        :selectedCity.sync="selectedCity"
        :selectedCountry.sync="selectedCountry"
        :selectedAreaType.sync="selectedAreaType"
    >
    </city-selector>
</template>

<script>
import CitySelector from './index'
import ajax from '@/api/ajax'
import { mapMutations, mapGetters } from 'vuex'
import { COUNTRY_CODE } from '@uip-alpha/business-constants'

export default {
    components: {
        'city-selector': CitySelector
    },
    props: {
        updateCityCode: {
            type: Function
        },
        updateSelect: {
            type: Function
        },
        updateZipCode: {
            type: Function
        },
        updateAreaCode: {
            type: Function
        },
        provinces: {
            type: Array,
            required: true
        },
        valid: {
            type: Boolean,
            default: true
        },
        input: {
            type: String,
            default: ''
        },
        updateArea: {
            type: Function,
            default: () => ({})
        },
        area: {
            type: Object,
            default: () => ({})
        },
        page: {
            type: String,
            default: ''
        },
        isDest: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            selectedProvince: {}, // 选择的省会
            selectedCity: {}, // 选择的城市
            selectedCountry: {}, // 选择的区域
            areaData: {
                provinces: [], // 省会列表
                cities: [], // 城市列表
                countries: [] // 区域列表
            },
            selectedAreaType: '', // 当前选择的区域状态
            selectCompleted: false,
            zipCode: '',
            zipError: false,
            initAreaData: [], // 存储符合搜索条件的国家名
            stopWatch: false, // 暂停watch selectedProvince selectedCity selectedCountry
            isSearching: false // 标识是否在搜索过程中
        }
    },
    methods: {
        ...mapMutations('range', {
            setSelectorValid: 'setSelectorValid',
            setAreaData: 'setAreaData',
            setAreaDataDest: 'setAreaDataDest'
        }),
        validZipCode(code) {
            let valid = false
            valid = !!code
            valid = valid && /^[A-Z0-9]*$/.test(code)
            return valid
        },
        /**
         * @Description 逐级查询国家省市信息
         * @param params 包含country、province、city三个字段
         * @returns {Promise<any>}
         */
        async syncGetIBULevelInfo(params) {
            this.$loading('加载中')
            const { data } = await ajax
                .getIBULevelInfo({
                    params
                })
                .catch(() => ({
                    data: {
                        code: 1
                    }
                }))
                .finally(() => {
                    this.$loading()
                })
            if (+data.code === 502) {
                return this.$toast('查询异常，请稍后再试')
            }
            return (!data.code && data.result && data.result.length && data.result) || []
        },
        /**
         * @Description 三个均为必填，优先调用上面接口获取相关信息
         * @Author 01376785
         * @Time 2018/6/15 11:35:56
         * @param country 国家代码
         * @param province 省代码
         * @param city 市代码
         * @param postCode 邮编
         * @returns {Promise<any>}
         */
        async asyncGetAreaDetailByCity() {
            const { data } = await ajax
                .getAreaDetailByCity({
                    data: {
                        country: this.selectedProvince.rateCode,
                        province: this.selectedCity.name || '',
                        city: this.selectedCountry.name || '',
                        postCode: ''
                    }
                })
                .catch(res => {
                    this.$toast('网络错误')
                })
            this.zipCode = (!data.code && data.result && data.result.postCode) || ''
            this.updateCityCode((!data.code && data.result && data.result.cityCode) || '')
            const valid = this.validZipCode(this.zipCode)
            this.updateSelect(valid)
        },
        init(val) {
            if (val && this.areaData && this.areaData.provinces) {
                this.isSearching = true
                // 筛选符合搜索关键词的集合
                const filterRes = this.initAreaData.provinces.filter(item => item.name.indexOf(val) > -1)
                // 高亮筛选后的结果
                this.areaData.provinces = this.highlightKey(filterRes, val)
                if (!this.areaData.provinces.length) {
                    // 匹配结果为空
                    this.$toast('对不起，查询不到数据')
                    return setTimeout(() => {
                        if (!this.selectCompleted) {
                            this.areaData = JSON.parse(JSON.stringify(this.initAreaData))
                        }
                    }, 100)
                } else {
                    // 有结果则重置选择器
                    this.selectedAreaType = 'province'
                    this.selectedProvince = {}
                    this.selectedCity = {}
                    this.selectedCountry = {}
                }
            } else if (this.isSearching) {
                // 在搜索过程中才需要清空
                // 清空关键词，还原所有国家数据
                this.selectedProvince = {}
                this.selectedCity = {}
                this.selectedCountry = {}
                this.selectedAreaType = 'province'
                this.areaData = JSON.parse(JSON.stringify(this.initAreaData))
            }
        },
        /**
         * 高亮关键字
         * @param {array} countryArr 国家数据数组
         * @param {string} key 关键字
         * @return {array} 源数据返回 更改name字段高亮
         */
        highlightKey(countryArr = [], key) {
            if (countryArr.length < 1) {
                return countryArr
            }
            // 拷贝数据
            const copyCountryArr = JSON.parse(JSON.stringify(countryArr))
            const reg = new RegExp(`(${key})`, 'g')
            copyCountryArr.forEach(country => {
                if (country.name) {
                    country.highlightName = country.name.replace(reg, '<i>$1</i>')
                }
            })
            return copyCountryArr
        },
        /**
         * 获取上次保存的数据
         */
        async checkLastData() {
            const { city, country, province } = this.isIntl(this.area.province && this.area.province.rateCode)
                ? this.isDest
                    ? this.getAreaDataDest || {}
                    : this.getAreaData || {}
                : {}
            // 国际与国内港澳台对应的字段不一致 需重新映射
            if (city && country && province) {
                // 暂停watch  selectedProvince selectedCity selectedCountry 避免重复请求
                this.stopWatch = true
                this.selectedProvince = province
                await this.setProvince(province)
                this.selectedCity = city
                await this.setCity(province, city)
                this.selectedCountry = country
                await this.setCountry(province, city, country)
                // 重启监听
                this.stopWatch = false
            }
        },
        /**
         * 设置Province
         */
        async setProvince(province) {
            const code = province.code
            const rateCode = province.rateCode
            const countryCode = province.countryCode
            this.updateAreaCode({ code, intl: true, areaName: province.name, rateCode, countryCode })
            this.selectCompleted = false
            this.zipCode = ''
            if (this.page === 'accept') {
                this.selectCompleted = true
                return
            }
            let cities = await this.syncGetIBULevelInfo({
                country: province.rateCode,
                province: ''
            })
            if (cities.length > 0) {
                cities = cities.map(item => ({ name: item }))
                this.areaData = { ...this.areaData, cities }
                this.selectedAreaType = 'city'
            }
            // 选择国家时 如果在搜索的过程中 则 还原国家列表选项 且重置标识
            if (this.isSearching) {
                this.areaData.provinces = this.initAreaData.provinces
                this.isSearching = false
            }
        },
        /**
         * 设置City
         */
        async setCity(province, city) {
            this.selectCompleted = false
            this.zipCode = ''
            let countries = await this.syncGetIBULevelInfo({
                country: province.rateCode,
                province: city.name
            })
            if (countries.length > 0) {
                countries = countries.map(item => ({ name: item }))
                this.areaData = { ...this.areaData, countries }
                this.selectedAreaType = 'country'
            } else {
                let areaName = [province.name, city.name, city.name].filter(item => !!item).join('-')
                if (areaName.endsWith('-')) {
                    areaName = areaName.slice(0, -1)
                }
                const code = province.code
                const rateCode = province.rateCode
                const countryCode = province.countryCode
                this.updateAreaCode({ code, areaName, rateCode, countryCode })
                this.selectCompleted = true
            }
        },
        /**
         * 设置Country
         */
        async setCountry(province, city, country) {
            this.selectCompleted = false
            let areaName = [province.name, city.name, country.name].filter(item => !!item).join('-')
            if (areaName.endsWith('-')) {
                areaName = areaName.slice(0, -1)
            }
            const code = province.code
            const rateCode = province.rateCode
            const countryCode = province.countryCode
            this.updateAreaCode({ code, areaName, rateCode, countryCode })
            this.selectCompleted = true
            this.asyncGetAreaDetailByCity()
        },
        isIntl(rateCode) {
            const pattern = new RegExp('[A-Za-z]+')
            return pattern.test(rateCode)
        }
    },
    computed: {
        ...mapGetters('range', {
            selectorValid: 'selectorValid',
            getAreaData: 'getAreaData',
            getAreaDataDest: 'getAreaDataDest'
        }),
        hasError() {
            return this.zipError || !this.selectorValid
        }
    },
    watch: {
        selectCompleted(val) {
            this.updateSelect(val) // 传递是否已选择状态给父组件
            this[this.isDest ? 'setAreaDataDest' : 'setAreaData']({
                province: this.selectedProvince,
                city: this.selectedCity,
                country: this.selectedCountry
            })
            if (val) {
                const code = (this.selectedProvince || {}).code
                const rateCode = this.selectedProvince.rateCode
                const countryCode = this.selectedProvince.countryCode
                let areaName = [this.selectedProvince.name, this.selectedCity.name, this.selectedCountry.name].filter(item => !!item).join('-')
                if (areaName.endsWith('-')) {
                    areaName = areaName.slice(0, -1)
                }
                this.updateArea({ code, areaName, rateCode, countryCode })
            }
        },
        zipCode(val) {
            if (!this.selectorValid) {
                // 服务端验证不通过，重置状态
                this.setSelectorValid(true)
            }
            const valid = this.validZipCode(val)
            this.zipError = !valid
            if (valid) {
                // 邮编验证通过,更新至父级元素
                this.updateZipCode(val)
            }
            this.selectCompleted = valid
            this.updateSelect(val) // 传递是否已选择状态给父组件
        },
        async selectedProvince(newVal, oldVal) {
            // 加载城市信息
            if (Object.keys(newVal || {}).length <= 0) {
                return
            }
            // 无更改不操作
            if (newVal === oldVal) {
                return
            }
            // 暂停监听不操作
            if (this.stopWatch) {
                return
            }
            await this.setProvince(this.selectedProvince)
        },
        async selectedCity(newVal, oldVal) {
            // 加载县区信息
            if (Object.keys(newVal || {}).length <= 0) {
                return
            }
            // 无更改不操作
            if (newVal === oldVal) {
                return
            }
            // 暂停监听不操作
            if (this.stopWatch) {
                return
            }
            await this.setCity(this.selectedProvince, this.selectedCity)
        },
        async selectedCountry(newVal, oldVal) {
            if (Object.keys(newVal || {}).length <= 0) {
                return
            }
            // 无更改不操作
            if (newVal === oldVal) {
                return
            }
            // 暂停监听不操作
            if (this.stopWatch) {
                return
            }
            await this.setCountry(this.selectedProvince, this.selectedCity, this.selectedCountry)
        },
        input(val) {
            this.init(val)
        }
    },
    created() {
        const provinces = this.provinces.filter(
            item => !([COUNTRY_CODE.HK, COUNTRY_CODE.MAC, COUNTRY_CODE.TW, COUNTRY_CODE.MAINLAND].indexOf(item.code) !== -1)
        )
        if (!provinces.length) {
            this.$toast('该地区暂时没有开通此业务')
        }
        this.areaData = {
            ...this.areaData,
            provinces
        }
        this.initAreaData = JSON.parse(JSON.stringify(this.areaData))
        this.selectedAreaType = 'province'
        this.init(this.input)
        // 检查是否有上一次选择的数据
        this.checkLastData()
    }
}
</script>

<style lang="scss" scoped>
.txt-zip {
    position: relative;
    input {
        border: 1px solid #f1f1f1;
        border-radius: 0.03rem;
        text-indent: 0.2rem;
        padding: 0;
        line-height: 2.5;
        border-radius: 0.05rem;
        color: #cccccc;
    }
    input:focus,
    .no-err {
        color: #333;
    }
    .err-zip {
        position: absolute;
        right: 1rem;
        color: #dc1e32;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/citySelector/area-intl.vue